import { render, staticRenderFns } from "./App.vue?vue&type=template&id=06ef2f0a&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=06ef2f0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ef2f0a",
  null
  
)

export default component.exports